import { render, staticRenderFns } from "./Tns.vue?vue&type=template&id=cbc9eb70&"
var script = {}
import style0 from "./Tns.vue?vue&type=style&index=0&id=cbc9eb70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports